import { Typography } from "@mui/material";
import { Link } from 'react-router-dom';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import { useSelector } from 'react-redux';
import { redirectTo, steps as totalSteps } from '../../Helper/AppStepperData';

function Breadcrumb(props) {
  const { steps, step, nestedStep, onClick, isObjectionScreen } = props;
  const stepper = useSelector(state => state.storeState.stepper) || [];

  function calculateEnableStep(currentStep) {
    if (stepper[step - 2]) {
      if (stepper[step - 2] === totalSteps[step - 2].nestedSteps.length) {
        if(stepper[step - 1]) {
          return currentStep <= stepper[step - 1]
        } else {
          return currentStep < nestedStep
        }
      }
    } else {
      return true
    }
  }

  return (
    steps ?
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {
          steps.map(((ele, index) => {
            let enable = isObjectionScreen ? false : index < stepper[step - 1] || calculateEnableStep(index);
            return <>
              <Link
                key={index}
                to={(enable && !onClick) ? redirectTo[ele] : ''}
                style={{ color: enable ? "#0098B0" : "#707070"/* "#24B7CC" */, opacity: enable ? 1 : 0.5, fontSize: 12, fontWeight: index === nestedStep ? 600 : 500, textDecoration: 'underline', cursor: enable ? "pointer" : "inherit" }}
                onClick={(enable && onClick) ? () => onClick(ele) : () => { }}
              >
                {ele}
              </Link>
              {steps[index + 1] && <Typography variant="caption" style={{ color: 'grey', padding: '0px 6px', lineHeight: 0 }}><DoubleArrowIcon style={{ width: 12, height: 12 }} /></Typography>}
            </>
          }))
        }
      </div>
      :
      <></>
  )

}

export default Breadcrumb;